"use client"

import { useEffect, useState } from "react"
import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  // ⚠️ Toast position is a PLATFORM decision, not a constant. top-right put
  // every toast under the iOS status bar / Dynamic Island and over the app
  // header. Native gets the snackbar convention: bottom-center, lifted above
  // the tab bar and the home indicator. Detected in an effect so SSR and the
  // first client paint agree.
  const [isNative, setIsNative] = useState(false)
  useEffect(() => {
    import("@/lib/capacitor/platform")
      .then((m) => setIsNative(m.isNativePlatform()))
      .catch(() => {})
  }, [])

  return (
    <Sonner
      theme="light"
      position={isNative ? "bottom-center" : "top-right"}
      // 56px tab bar + home indicator + breathing room.
      // ⚠️ MUST be the object form: a single offset value applies to ALL FOUR
      // sides — the ~134px bottom lift became 134px left+right margins too,
      // squeezing every toast to ~170px and wrapping copy one char per line.
      offset={isNative ? { bottom: "calc(env(safe-area-inset-bottom, 0px) + 100px)", left: 16, right: 16 } : undefined}
      mobileOffset={isNative ? { bottom: "calc(env(safe-area-inset-bottom, 0px) + 100px)", left: 16, right: 16 } : undefined}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-gray-900 group-[.toaster]:border-gray-200 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-gray-600",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
